/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/SpiderGameMode',[
		'Solitaire/GameModes/GameModeBase',
		'Solitaire/GameModes/IGameMode',
		'Solitaire/Solitaire',
		'Solitaire/SolitaireGameMode',
		'SolitaireShared/SpiderTemplate/SpiderWindowsTemplate',
		'SolitaireShared/CardLogic/Supply',
		'Solitaire/GameResult',
		'Solitaire/GameState',
		'Solitaire/SolitaireStatistics'],
	function (GameModeBase, IGameMode, SolitaireGame, SolitaireGameMode, SpiderWindowsTemplate, Supply, GameResult, GameState, SolitaireStatistics) {
		"use strict";

		var SpiderGameMode = function () {
			this.initSpiderGameMode();
		};

		SpiderGameMode.constructor = SpiderGameMode;
		SpiderGameMode.prototype = Object.create(GameModeBase.prototype);
		IGameMode.call(SpiderGameMode.prototype);

		SpiderGameMode.prototype.initSpiderGameMode = function () {
			this.Name = SolitaireGameMode.Spider;
		};

		Object.defineProperty(SpiderGameMode.prototype, "TimerOption", {
			get: function () {
				if (GameState.CurrentGame.Authority.IsChallenge) {
					return GameState.CurrentGame.Authority.TimerEnabled ? IGameMode.TimerSettings.CountDown : IGameMode.TimerSettings.CountUp;
				}
				return IGameMode.TimerSettings.CountUp;
			}
		});

		SpiderGameMode.prototype.OnMoveCardButton = function () {
		};


		SpiderGameMode.prototype.IsUpdateDealButtonsVisible = function () {
			return false;
		};


		SpiderGameMode.prototype.IsUpdateDrawButtonVisible = function () {
			return false;
		};


		SpiderGameMode.prototype.ConfigureSolitairePage = function (page) {
			Supply.UseCumulativeScoring = false;
		};


		SpiderGameMode.prototype.CreateTemplate = function () {
			return new SpiderWindowsTemplate();
		};


		SpiderGameMode.prototype.GetCheatMoves = function () {
			return "G SPIDER O SUITS 1 D 1204270129394494717836683660838923034543815746289121040560454131772628145613822745923526435696642396914842557418960399254184196261880840500047432460549037 B M 20 26 1 M 19 20 1 E [2] B M 14 24 1 M 13 14 1 E [3] B M 22 24 1 M 21 22 1 E [4] B M 24 18 3 M 23 24 1 E [5] B M 14 18 1 M 13 14 1 E [6] B M 30 22 1 M 29 30 1 E [9] B M 14 22 1 M 13 14 1 E [12] B M 12 26 1 M 11 12 1 E [14] B M 2 12 1 M 2 14 1 M 2 16 1 M 2 18 1 M 2 20 1 M 2 22 1 M 2 24 1 M 2 26 1 M 2 28 1 M 2 30 1 E [16] M 16 12 1 [18] M 18 22 1 [18] B M 18 22 5 M 17 18 1 E [20] M 22 14 7 [25] B M 2 12 1 M 2 14 1 M 2 16 1 M 2 18 1 M 2 20 1 M 2 22 1 M 2 24 1 M 2 26 1 M 2 28 1 M 2 30 1 E [27] U 1 [28] U 1 [30] M 12 14 2 [32] M 14 12 3 [34] M 22 12 5 [39] B M 14 24 1 M 13 14 1 E [42] M 26 14 1 [43] B M 14 28 2 M 13 14 1 E [44] M 28 26 2 [46] M 22 26 1 [49] U 1 [51] U 1 [53] M 28 26 2 [55] M 22 26 1 [60] M 14 30 1 [62] M 22 14 1 [64] M 30 22 2 [66] B M 22 26 5 M 21 22 1 E [69] M 14 22 1 [71] B M 26 14 11 M 25 26 1 E [73] M 28 26 1 [74] B M 22 26 2 M 21 22 1 E [110] B M 26 18 4 M 25 26 1 E [117] M 12 18 6 [147] B M 2 12 1 M 2 14 1 M 2 16 1 M 2 18 1 M 2 20 1 M 2 22 1 M 2 24 1 M 2 26 1 M 2 28 1 M 2 30 1 E [149] M 28 24 1 [151] M 26 28 1 [152] M 20 24 1 [154] M 22 20 1 [158] M 14 16 1 [159] B M 14 20 11 M 20 3 -13 E [161] M 16 20 2 [164] B M 20 24 3 M 19 20 1 E [167] M 18 14 1 [168] B M 12 14 4 M 11 12 1 E [169] B M 12 14 1 M 11 12 1 E [171] M 30 24 1 [173] B M 26 20 1 M 25 26 1 E [174] B M 12 16 1 M 11 12 1 E [175] B M 18 16 11 M 17 18 1 M 16 4 -13 M 15 16 1 E [177] B M 18 12 1 M 17 18 1 E [179] B M 18 28 1 M 17 18 1 E [181] B M 22 12 1 M 21 22 1 E [182] B M 18 14 1 M 17 18 1 E [184] M 18 14 1 [185] B M 20 14 2 M 19 20 1 E [188] B M 20 24 1 M 19 20 1 E [189] B M 26 24 1 M 25 26 1 E [190] M 22 24 1 [191] B M 24 28 10 M 28 5 -13 M 27 28 1 E [193] M 20 16 1 [194] B M 16 18 2 M 15 16 1 E [195] B M 30 20 1 M 29 30 1 E [198] B M 16 30 1 M 15 16 1 E [199] B M 28 30 1 M 27 28 1 E [201] B M 16 12 1 M 15 16 1 E [206] B M 12 18 4 M 11 12 1 E [207] B M 14 18 7 M 18 6 -13 E [212] B M 16 18 1 M 15 16 1 E [214] M 24 30 1 [215] M 24 22 1 [216] B M 24 22 1 M 23 24 1 E [217] M 22 12 2 [218] B M 24 22 1 M 23 24 1 E [225] B M 2 12 1 M 2 14 1 M 2 16 1 M 2 18 1 M 2 20 1 M 2 22 1 M 2 24 1 M 2 26 1 M 2 28 1 M 2 30 1 E [228] M 26 22 1 [228] M 22 20 2 [230] M 20 14 3 [231] M 14 18 4 [232] M 18 14 5 [235] M 24 12 1 [239] M 30 18 1 [240] B M 30 18 4 M 29 30 1 E [242] B M 30 14 1 M 29 30 1 E [253] B M 2 12 1 M 2 14 1 M 2 16 1 M 2 18 1 M 2 20 1 M 2 22 1 M 2 24 1 M 2 26 1 M 2 28 1 M 2 30 1 E [254] M 28 18 1 [255] M 18 22 2 [257] M 26 28 1 [258] M 26 28 1 [260] M 20 28 1 [261] M 24 28 1 [264] M 12 20 1 [270] M 12 26 2 [271] M 12 22 3 [288] B M 28 12 6 M 27 28 1 E [289] B M 28 30 1 M 27 28 1 E [292] B M 24 30 1 M 23 24 1 E [296] M 30 24 3 [303] M 16 30 1 [321] B M 2 12 1 M 2 14 1 M 2 16 1 M 2 18 1 M 2 20 1 M 2 22 1 M 2 24 1 M 2 26 1 M 2 28 1 M 2 30 1 E [323] M 28 26 1 [324] M 24 26 2 [325] M 28 26 1 [326] M 30 26 1 [327] M 30 26 2 [331] M 26 24 6 [334] M 22 14 1 [335] M 14 24 2 [335] B M 22 24 2 M 24 7 -13 E [338] M 14 16 1 [340] M 14 12 5 [343] M 16 24 2 [344] M 16 28 1 [345] M 26 28 2 [346] B M 26 12 1 M 12 8 -13 E [348] M 16 26 1 [348] M 26 22 2 [351] M 22 20 6 [352] M 20 24 7 [353] M 24 22 9 [354] B M 22 28 10 M 28 9 -13 E [355] M 18 20 1 [359] M 14 20 4 [362] M 18 16 1 [362] M 18 20 5 [364] M 16 18 1 [364] N";
		};

		SpiderGameMode.prototype.HelpDataSource = function () {
			return null; // TODO not supported? return SimpleIoc.Default.GetInstance<MvvmStructure.Model.SpiderHelpDataSource>();
		};

		SpiderGameMode.prototype.ButtonsPostion = function (invertAxis) {
			return null; // TODO not supported?
			//return new Dictionary<GameButtons, Vector2>();
		};

		SpiderGameMode.prototype.GetGameEnd = function () {
			throw "TODO";
			return null;
			/*
			 var model = new GameEndModel
			 {
			 LockIconSourcePath = "Assets/ui/icons/update.png",
			 };

			 model.AddStatValue("ScoreText", LocalizationManager.GetString("YouScoredColon_Title/Text"), GameEndTileTemplates.Highlighted);
			 model.AddStatValue("HighScore", LocalizationManager.GetString("HighScore_Title/Text"), GameEndTileTemplates.Highlighted);
			 model.AddStatValue("Time", LocalizationManager.GetString("Time_Title/Text"));
			 model.AddStatValue("BestTime", LocalizationManager.GetString("BestTime_Title/Text"));
			 model.AddStatValue("GamesPlayed", LocalizationManager.GetString("GamesPlayed_Title/Text"));
			 model.AddStatValue("GamesWon", LocalizationManager.GetString("GamesWon_Title/Text"));
			 model.AddStatValue("WinPercentage", LocalizationManager.GetString("WinPercentage_Title/Text"));

			 model.AddStatValue("Stacks", LocalizationManager.GetString("Stacks_Title/Text"));
			 model.Optional1ButtonText = LocalizationManager.GetString("OptionalButton_TryAgain");
			 model.Optional1Visibility = Visibility.Visible;
			 SetDefaults(model);
			 model.UpdateStatistics = UpdateStatistics;
			 return model;
			 */
		};

		SpiderGameMode.prototype.SetShare = function (args) {
			// TODO
			/*
			 var description = new StringBuilder();
			 var message = new StringBuilder();
			 string gameTitle = LocalizationManager.GetLocalizedString("SolitaireCollection_Title/Text");
			 description.Append(LocalizationManager.GetString(string.Format("Share_Description_{0}", Name.ToString())));
			 message.Append(LocalizationManager.GetString(string.Format("Share_Description_{0}", Name.ToString())));
			 message.Replace("%GAME_TITLE%", gameTitle).Replace("%SCORE%", GameState.CurrentGame.Authority.CardSupply.NumSuits.ToString());
			 ShareManager.SetShareMessage(args, gameTitle, description, message);
			 */
		};

		SpiderGameMode.GetStatKeyStatic = function () {
			return new SolitaireStatistics.StatKey(GameState.CurrentGame.ActiveMode.Name,
				(GameState.CurrentGame.GetOption("SUITS") + SolitaireGameMode.getModeById(GameState.CurrentGame.ActiveMode.Name)).toUpperCase());
		};

		SpiderGameMode.prototype.GetStatKey = function () {
			return SpiderGameMode.GetStatKeyStatic();
		};

		SpiderGameMode.prototype.UpdateStatistics = function (model) {
			// TODO

			//if (GameState.CurrentGame.ActiveMode.Name == SolitaireGameMode.Unknown) return;

			var statkey = SpiderGameMode.GetStatKeyStatic();

			if (GameState.CurrentGame.GameResult == GameResult.Win) {
				//User Won here so update stats and save them to disk
				SolitaireStatistics.Current.UpdateGameWon(statkey);
				//model.Optional1ButtonText = "";
				//model.Optional1Visibility = Visibility.Collapsed;
			} else if (GameState.Current == GameState.GameComplete) {
				//User Lost here so update stats and save them to disk
				SolitaireStatistics.Current.UpdateGameLost(statkey);
				//model.Optional1ButtonText = LocalizationManager.GetString("OptionalButton_TryAgain");
				//model.Optional1Visibility = Visibility.Visible;
			}

			//Update GameEnd Model with Latest Stats
			model["ScoreText"] = SolitaireStatistics.Current.GetScoreFormatString(statkey);
			model["Time"] = SolitaireStatistics.Current.GetTimeFormatString(statkey);
			model["HighScore"] = SolitaireStatistics.Current.GetHighScoreFormatString(statkey);
			model["BestTime"] = SolitaireStatistics.Current.GetBestTimeFormatString(statkey);
			model["GamesPlayed"] = SolitaireStatistics.Current.GetGamesPlayedFormatString(statkey);
			model["GamesWon"] = SolitaireStatistics.Current.GetGamesWonFormatString(statkey);
			model["WinPercentage"] = SolitaireStatistics.Current.GetPercentWon(statkey);

			model["Stacks"] = SolitaireStatistics.Current.GetStacksFormatString(statkey);
			//UpdateLiveTile();

		};

		SpiderGameMode.prototype.UpdateLeaderBoard = function () {
			// unsupported
			/*
			 var current = GameState.CurrentGame;
			 var stats = SolitaireStatistics.Current;
			 var statkey = GetStatKeyStatic();
			 if ( App.CurrentApp.GameNetClient.Settings.XblConnected)
			 {
			 Arkadium.SharedEntities.ResultObject<string> result; //string result;

			 // high score
			 uint lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.Key + SolitaireLeaderboards.HIGHSCORE];
			 result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetHighScore(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Max);

			 // best time
			 lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.Key + SolitaireLeaderboards.FASTESTTIME];
			 result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetBestTime(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Min);

			 // longest winning streak
			 //lbId = SolitaireLeaderboards.Current.modeToLeaderboard[statkey.Key + SolitaireLeaderboards.LONGESTWINNINGSTREAK];
			 //result = await App.CurrentApp.GameNetClient.LeaderboardManager.SaveScore((int)stats.GetLongestWinningStreak(statkey), lbId, Microsoft.Xbox.Leaderboards.LeaderboardAggregation.Replace);
			 }
			 */
		};

		return SpiderGameMode;

	});

